// extracted by mini-css-extract-plugin
module.exports = {"articleSet":"style-module__articleSet___1zpsK","articleLink":"style-module__articleLink___h7Rto"};